var _circle, _path, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPartiallySet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#E8E7EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03783 4.83236L5.63396 9.28491C5.61882 9.31295 5.59699 9.3366 5.56987 9.35377L3.94394 10.3927C3.92898 10.4022 3.91297 10.4093 3.89663 10.4142C3.84944 10.4283 3.79827 10.4234 3.75381 10.3994C3.69404 10.3669 3.65638 10.3049 3.65548 10.2366L3.63247 8.30714C3.63205 8.27535 3.63976 8.24382 3.6549 8.21579L6.05927 3.76377C6.28001 3.35451 6.79298 3.20164 7.20191 3.4225L7.69655 3.68965C7.89471 3.79642 8.03961 3.97452 8.10409 4.19042C8.16848 4.40601 8.1449 4.6341 8.03783 4.83236Z",
    fill: "#BFBEC6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 9.5,
    x2: 11,
    y2: 9.5,
    stroke: "#BFBEC6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPartiallySet);
export default __webpack_public_path__ + "static/media/icon-partially-set.c42a05c4.svg";
export { ForwardRef as ReactComponent };